import '../../components/Industries/IndustriesSlider/industries.scss';

export const ButtonArrowIcon = ({ color = 'white' }: {color?: 'white' | 'black'}) => {
    return (
        <svg className={`buttonArrowIcon ${color === 'white' ? 'buttonArrowIconWhite' : 'buttonArrowIconBlack'}`} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M15.134 6.09L14.073 5.03L8.29395 10.807C8.2008 10.8996 8.12687 11.0096 8.07642 11.1309C8.02597 11.2521 8 11.3822 8 11.5135C8 11.6448 8.02597 11.7749 8.07642 11.8961C8.12687 12.0174 8.2008 12.1274 8.29395 12.22L14.073 18L15.133 16.94L9.70895 11.515L15.134 6.09Z"
            />
        </svg>
    );
};